<template>
    <div class='page'>
        <!-- 搜索 -->
        <el-form v-if='isSearch' :model='queryForm' ref='form' label-width='80px' :inline='true' size='small' class='query-form' @submit.native.prevent>
            <el-form-item label='活动名称'>
                <el-input style='width: 177px;' v-model="queryForm.name" clearable></el-input>
            </el-form-item>
            <el-form-item label='活动编码'>
                <el-input style='width: 177px;' v-model="queryForm.code" clearable></el-input>
            </el-form-item>
            <el-form-item label='活动状态'>
                <el-select style='width: 177px;' v-model="queryForm.status" placeholder="请选择" clearable size="small">
                    <el-option v-for="item in statusMenu" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item>
                <el-button size='small' type='primary' icon='el-icon-search' @click='getActivityList'>查询</el-button>
                <el-button size='small' icon='el-icon-refresh' @click='resetQuery'>重置</el-button>
            </el-form-item>
        </el-form>
        <div class='page-content'>
            <div class='page-tool-bar'>
                <div class='el-btn-group'>
                    <el-button
                        type='primary'
                        size='small'
                        icon='el-icon-plus'
                        @click='addActivity'
                    >新建
                    </el-button>
                </div>
                <div class='icon-group'>
                    <span
                        title='搜索'
                        class='icon-box'
                        @click='toggleSearch'
                    >
                        <Icon color='#606266'>
                            <Search />
                        </Icon>
                    </span>
                    <span
                        class='icon-box'
                        title='刷新'
                        @click='refreshActivityList'
                    >
                        <Icon color='#606266'>
                            <Refresh />
                        </Icon>
                    </span>
                </div>
            </div>
            <!-- 列表 -->
            <el-table
                height='100%'
                :data='activityList'
                row-key='id'
                border
                v-loading='tableLoading'
                :header-row-style="{height: '10px'}"
                :header-cell-style="{padding: '10px'}"
                :row-style="{height: '9px'}"
                :cell-style="{padding: '9px'}"
                size='small'
            >
                <el-table-column align='center' prop='name' label='活动名称' min-width='140' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' prop='startTime' label='开始时间' min-width='160'></el-table-column>
                <el-table-column align='center' prop='endTime' label='结束时间' min-width='160'></el-table-column>
                <el-table-column align='center' prop='status' label='活动状态' width='100'>
                    <template slot-scope='scope'>
                        {{ statusLabel(scope.row.status) }}
                    </template>
                </el-table-column>
                <el-table-column align='center' prop='description' label='活动说明' min-width='160' show-overflow-tooltip></el-table-column>
                <el-table-column align='center' label='操作' fixed='right' width='260'>
                    <template slot-scope='{ row }'>
                        <el-button size='small' type="text" @click='registration(row)'>报名</el-button>
                        <el-button size='small' type="text" @click='registered(row)'>已报名</el-button>
                        <el-button size='small' type="text" @click='ranking(row)'>榜单</el-button>
                        <el-button size='small' type="text" @click='editActivity(row)'>编辑</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!-- 新建 / 编辑活动弹框 -->
        <el-dialog
            :title='activityDialogTitle'
            :visible.sync='addActivityDialogVisible'
            width='560px'
            :close-on-click-modal='false'
            @close='closeAddDialog'
        >
            <el-form
                :model='activityForm'
                :rules='activityFormRules'
                ref='activityForm'
                label-width='100px'
                size='small'
            >
                <el-form-item label='活动名称' prop='name'>
                    <el-input v-model='activityForm.name' placeholder='请输入活动名称' maxlength='100' show-word-limit clearable></el-input>
                </el-form-item>
                <el-form-item label='开始时间' prop='startTime'>
                    <el-date-picker
                        v-model='activityForm.startTime'
                        type='datetime'
                        placeholder='选择开始时间'
                        style='width: 100%;'
                        format='yyyy-MM-dd HH:mm:ss'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        :picker-options='startTimePickerOptions'
                        @change='() => { activityForm.endTime = ""; }'
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label='结束时间' prop='endTime'>
                    <el-date-picker
                        v-model='activityForm.endTime'
                        type='datetime'
                        placeholder='选择结束时间'
                        style='width: 100%;'
                        format='yyyy-MM-dd HH:mm:ss'
                        value-format='yyyy-MM-dd HH:mm:ss'
                        :picker-options='endTimePickerOptions'
                    ></el-date-picker>
                </el-form-item>
                <el-form-item label='活动状态' prop='status'>
                    <el-select v-model='activityForm.status' placeholder='请选择' style='width: 100%;'>
                        <el-option v-for='item in statusMenu' :key='item.value' :label='item.label' :value='item.value'></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label='活动说明' prop='description'>
                    <el-input
                        v-model='activityForm.description'
                        type='textarea'
                        :rows='3'
                        placeholder='选填'
                        maxlength='500'
                        show-word-limit
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button size='small' @click='closeAddDialog'>取消</el-button>
                <el-button size='small' type='primary' :loading='submitLoading' @click='submitActivity'>确定</el-button>
            </div>
        </el-dialog>

        <!-- 报名弹框 -->
        <el-dialog
            title='报名'
            :visible.sync='registrationDialogVisible'
            width='560px'
            :close-on-click-modal='false'
            @close='closeRegistrationDialog'
        >
            <el-form
                :model='registrationForm'
                label-width='100px'
                size='small'
            >
                <el-form-item label='报名人员' prop='name'>
                    <GridSelectU style="width: 200px;" title="请选择报名人员" labelName="userName"
                                labelValue="id" :value="registrationForm.userId" :limit='1' size='small'
                                placeholder='请选择报名人员'
                                @getValue="getSearchValueUser" :columns="USER_code" :searchs="USER_search"
                                dataListUrl="/mpp/user/findList" entityBeanName="mppUser"
                                queryEntityUrl="/mpp/user/get">
                    </GridSelectU>
                </el-form-item>
            </el-form>
            <div slot='footer' class='dialog-footer'>
                <el-button size='small' @click='closeRegistrationDialog'>取消</el-button>
                <el-button size='small' type='primary' :loading='submitLoading' @click='submitRegistration'>确定</el-button>
            </div>
        </el-dialog>

        <!-- 查看已报名人员弹框 -->
        <el-dialog
            title='已报名'
            :visible.sync='registeredDialogVisible'
            width='50vw'
            :close-on-click-modal='false'
            @close='closeRegisteredDialog'
        >
            <el-form ref='registeredForm' :model='registeredData' size='small' :inline='true'>
                <el-form-item label='手机号' prop='userMobile'>
                    <el-input v-model='registeredData.userMobile' placeholder='请输入手机号'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size='small' type='primary' icon='el-icon-search' @click='() => { registeredData.pageNum = 1; searchRegistered(); }'>查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data='registeredData.list'
                border
                size='small'
            >
                <el-table-column prop='userId' label='用户ID'></el-table-column>
                <el-table-column prop='userName' label='用户名'></el-table-column>
                <el-table-column prop='userNickname' label='用户昵称'></el-table-column>
                <el-table-column prop='userMobile' label='手机号'></el-table-column>
                <el-table-column prop='createTime' label='报名时间'></el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { registeredPager.pageSize = size; searchRegistered(); }'
                    @current-change='(page) => { registeredPager.pageNum = page; searchRegistered(); }'
                    :current-page='registeredPager.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='registeredPager.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='registeredData.total'>
                </el-pagination>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button size='small' @click='closeRegisteredDialog'>取消</el-button>
            </div>
        </el-dialog>

        <!-- 查看榜单弹框 -->
        <el-dialog
            title='榜单'
            :visible.sync='rankingDialogVisible'
            width='50vw'
            :close-on-click-modal='false'
            @close='closeRankingDialog'
        >
            <el-form ref='registeredForm' :model='rankingData' size='small' :inline='true'>
                <el-form-item label='手机号' prop='userMobile'>
                    <el-input v-model='rankingData.userMobile' placeholder='请输入手机号'></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size='small' type='primary' icon='el-icon-search' @click='() => { rankingPager.pageNum = 1; searchRanking(); }'>查询</el-button>
                </el-form-item>
            </el-form>
            <el-table
                :data='rankingData.list'
                border
                size='small'
            >
                <el-table-column prop='userName' label='姓名'></el-table-column>
                <el-table-column prop='userMobile' label='手机号'></el-table-column>
                <el-table-column prop='personalPerformance' label='个人业绩'></el-table-column>
                <el-table-column prop='personalServiceFee' label='个人让利'></el-table-column>
                <el-table-column prop='teamPerformance' label='团队业绩'></el-table-column>
                <el-table-column prop='teamServiceFee' label='团队让利'></el-table-column>
                <el-table-column prop='totalPerformance' label='总业绩'></el-table-column>
            </el-table>
            <div class='pagination-box'>
                <el-pagination
                    @size-change='(size) => { rankingPager.pageSize = size; searchRanking(); }'
                    @current-change='(page) => { rankingPager.pageNum = page; searchRanking(); }'
                    :current-page='rankingPager.pageNum'
                    :page-sizes='[10, 20, 50, 100]'
                    :page-size='rankingPager.pageSize'
                    layout='total, sizes, prev, pager, next, jumper'
                    :total='rankingData.total'>
                </el-pagination>
            </div>
            <div slot='footer' class='dialog-footer'>
                <el-button size='small' @click='closeRankingDialog'>取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { Refresh, Search } from '@v2icons/tabler';
import { post, postJson, get } from '@/utils/request.js';
import GridSelectU from '@/components/gridselect/index.vue';
import { UPLOAD_API, UPLOAD_PATH, USER, USER_SEARCH } from '@/utils/constant';

export default {
    name: 'ActivityManage',
    components: {
        Search,
        Refresh,
        GridSelectU
    },
    data() {
        const validateEndTime = (rule, value, callback) => {
            if (!value) {
                callback(new Error('请选择结束时间'));
                return;
            }
            const { startTime } = this.activityForm;
            if (startTime && value <= startTime) {
                callback(new Error('结束时间须晚于开始时间'));
                return;
            }
            callback();
        };

        return {
            isSearch: false,
            tableLoading: false,
            submitLoading: false,
            queryForm: {
                name: '',
                code: '',
                status: ''
            },
            activityList: [],
            statusMenu: [
                { value: 0, label: '未开始' },
                { value: 1, label: '进行中' },
                { value: 2, label: '已结束' },
                { value: 3, label: '已关闭' }
            ],
            /** 非 null 表示当前为编辑模式，值为活动 id */
            activityEditingId: null,
            addActivityDialogVisible: false,
            activityForm: {
                name: '',
                startTime: '',
                endTime: '',
                status: 0,
                description: ''
            },
            activityFormRules: {
                name: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
                startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                endTime: [{ required: true, validator: validateEndTime, trigger: 'change' }],
                status: [{ required: true, message: '请选择活动状态', trigger: 'change' }]
            },
            registrationDialogVisible: false,
            registrationForm: {
                campaignId: '',
                userId: ''
            },
            USER_code: USER,
            USER_search: USER_SEARCH,
            registeredDialogVisible: false,
            registeredData: {
                campaignId: '',
                userMobile: '',
                list: [],
                total: 0
            },
            registeredPager: {
                pageNum: 1,
                pageSize: 10
            },
            rankingDialogVisible: false,
            rankingData: {
                campaignId: '',
                userMobile: '',
                list: [],
                total: 0
            },
            rankingPager: {
                pageNum: 1,
                pageSize: 10
            },
            startTimePickerOptions: {
                disabledDate: (time) => {
                    return time.getTime() < Date.now() - 86400000;
                }
            },
            endTimePickerOptions: {
                disabledDate: (time) => {
                    return this.activityForm.startTime ? time.getTime() < new Date(this.activityForm.startTime).getTime() : false;
                }
            }
        };
    },
    computed: {
        activityDialogTitle() {
            return this.activityEditingId != null ? '编辑活动' : '新建活动';
        }
    },
    mounted() {
        this.getActivityList();
    },
    methods: {
        statusLabel(status) {
            const item = this.statusMenu.find((s) => s.value === status);
            return item ? item.label : '--';
        },
        toggleSearch() {
            this.isSearch = !this.isSearch;
        },
        getActivityList() {
            this.tableLoading = true;
            get(`/shop/marketing/campaign/findList`, { ...this.queryForm }).then((res) => {
                this.tableLoading = false;
                if (res.success) {
                    this.activityList = res.list;
                    console.log("this.activityList=========>", this.activityList);
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        resetQuery() {
            this.queryForm = {
                name: '',
                code: '',
                status: ''
            };
            this.getActivityList();
        },
        refreshActivityList() {
            this.getActivityList();
        },
        addActivity() {
            this.activityEditingId = null;
            this.activityForm = {
                name: '',
                startTime: '',
                endTime: '',
                status: 0,
                description: ''
            };
            this.addActivityDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.activityForm) {
                    this.$refs.activityForm.clearValidate();
                }
            });
        },
        editActivity(row) {
            this.activityEditingId = row.id;
            this.activityForm = {
                name: row.name || '',
                startTime: row.startTime || '',
                endTime: row.endTime || '',
                status: typeof row.status === 'number' ? row.status : 0,
                description: row.description || ''
            };
            this.addActivityDialogVisible = true;
            this.$nextTick(() => {
                if (this.$refs.activityForm) {
                    this.$refs.activityForm.clearValidate();
                }
            });
        },
        closeAddDialog() {
            this.addActivityDialogVisible = false;
            this.resetActivityForm();
        },
        resetActivityForm() {
            this.activityEditingId = null;
            this.activityForm = {
                name: '',
                startTime: '',
                endTime: '',
                status: 0,
                description: ''
            };
            if (this.$refs.activityForm) {
                this.$refs.activityForm.resetFields();
            }
        },
        submitActivity() {
            this.$refs.activityForm.validate((valid) => {
                if (!valid) {
                    return;
                }
                if (this.activityEditingId != null) {
                    this.submitActivityEdit();
                    return;
                }
                this.submitLoading = true;
                postJson(`/shop/marketing/campaign/save`, { ...this.activityForm }).then((res) => {
                    this.submitLoading = false;
                    if (res.success) {
                        this.$message({
                            message: "添加成功",
                            type: 'success',
                            duration: 2000
                        });
                        this.closeAddDialog();
                        this.resetQuery();
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            });
        },
        submitActivityEdit() {
            this.submitLoading = true;
            postJson(`/shop/marketing/campaign/update`, { id: this.activityEditingId, ...this.activityForm }).then((res) => {
                this.submitLoading = false;
                if (res.success) {
                    this.$message({
                        message: "修改成功",
                        type: 'success',
                        duration: 2000
                    });
                    this.closeAddDialog();
                    this.resetQuery();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        registration(row) {
            this.registrationForm.campaignId = row.id;
            this.registrationDialogVisible = true;
        },
        getSearchValueUser(val){
            this.registrationForm.userId = val;
        },
        closeRegistrationDialog() {
            this.registrationDialogVisible = false;
            this.registrationForm = {
                campaignId: '',
                userId: ''
            };
        },
        submitRegistration() {
            this.submitLoading = true;
            post(`/shop/marketing/campaign/enroll`, { ...this.registrationForm }).then((res) => {
                this.submitLoading = false;
                if (res.success) {
                    this.$message({
                        message: "报名成功",
                        type: 'success',
                        duration: 2000
                    });
                    this.closeRegistrationDialog();
                    this.resetQuery();
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        registered(row) {
            get(`/shop/marketing/campaign/enroll/list`, { campaignId: row.id, ...this.registeredPager }).then((res) => {
                if (res.success) {
                    this.registeredData.campaignId = row.id;
                    this.registeredData.list = res.page.list;
                    this.registeredData.total = res.page.total;
                    this.registeredDialogVisible = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        searchRegistered() {
            get(`/shop/marketing/campaign/enroll/list`, { campaignId: this.registeredData.campaignId, userMobile: this.registeredData.userMobile, ...this.registeredPager }).then((res) => {
                if (res.success) {
                    this.registeredData.list = res.page.list;
                    this.registeredData.total = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        closeRegisteredDialog() {
            this.registeredDialogVisible = false;
            this.registeredData = {
                campaignId: '',
                userMobile: '',
                list: [],
                total: 0
            };
            this.registeredPager = {
                pageNum: 1,
                pageSize: 10
            };
        },
        ranking(row) {
            get(`/shop/marketing/campaign/rank`, { campaignId: row.id, ...this.rankingPager }).then((res) => {
                if (res.success) {
                    this.rankingData.campaignId = row.id;
                    this.rankingData.list = res.page.list;
                    this.rankingData.total = res.page.total;
                    this.rankingDialogVisible = true;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        searchRanking() {
            console.log("this.rankingData=========>", this.rankingData);
            get(`/shop/marketing/campaign/rank`, { campaignId: this.rankingData.campaignId, userMobile: this.rankingData.userMobile, ...this.rankingPager }).then((res) => {
                if (res.success) {
                    this.rankingData.list = res.page.list;
                    this.rankingData.total = res.page.total;
                } else {
                    this.$message({
                        message: res.msg,
                        type: 'error',
                        duration: 2000
                    });
                }
            });
        },
        closeRankingDialog() {
            this.rankingDialogVisible = false;
            this.rankingData = {
                campaignId: '',
                userMobile: '',
                list: [],
                total: 0
            };
            this.rankingPager = {
                pageNum: 1,
                pageSize: 10
            };
        },
    }
};

</script>

<style scoped></style>

